import { injectable } from "@launchtray/tsyringe-async";
import { BoosterType } from "./data/BoosterType";
import config from "../configs/boosters.json";
import { EnergyBoosterData } from "./data/EnergyBoosterData";
import { FreezeBoosterData } from "./data/FreezeBoosterData";
import { MineBoosterData } from "./data/MineBoosterData";
import { TurretBoosterData } from "./data/TurretBoosterData";

@injectable()
export class BoostersConfiguration {
    private configurations: ReadonlyMap<BoosterType, EnergyBoosterData[] | FreezeBoosterData[] | MineBoosterData[] | TurretBoosterData[]>;
    public constructor() {
        this.configurations = new Map<BoosterType, EnergyBoosterData[] | FreezeBoosterData[] | MineBoosterData[] | TurretBoosterData[]>([
            [BoosterType.Energy, config.energy],
            [BoosterType.Freeze, config.freeze],
            [BoosterType.Mine, config.mine],
            [BoosterType.Turret, config.turret],
        ]);
    }

    public getConfiguration(type: BoosterType, level: number): EnergyBoosterData | FreezeBoosterData | MineBoosterData | TurretBoosterData {
        return this.configurations.get(type).find(item => item.level === level);
    }
}
